import React from 'react';

import CompanyLogo from '../../../components/companyLogo';
import { buildCppSubpageUrl, formatNumber,formatSubPageText } from '../../../utils';
import { CLUSTER_HEADER_CATEGORY,CMP_SUBPAGES, CPP_SUBPAGES } from '../../../utils/constant';

class CompanyClusterHeaderTitle extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { title, subTitle, subPageName, data } = this.props;
    const {
      canClaimCompany,
      claimedCompany,
      isVerifiedByEmployer,
      desktopDevice,
      jobsCountForHeader,
      showJobsCount,
    } = data;
    const {
      companyLogo,
      overallScore,
      starRatingCssName,
      companyID,
      companyNameCPS,
      companyJobsCount,
      displayFlagOfCompanyJobsPage,
      companyLink,
    } = data.companyInfo;
    const ClusterHeaderTitleHeading = subPageName === CMP_SUBPAGES.REVIEWS ? 'h2' : 'h1';
    const imgWidthHeight = desktopDevice ? 100 : 92.16;
    const imgWidth = imgWidthHeight;
    const imgHeight = imgWidthHeight;

    return (
      <div className="company-header-container position-relative z-my-36 w-100">
        <div className="company-logo-placeholder z-ml-12 z-ml-md-0">
          <CompanyLogo
            className="clusterHeaderCompanyLogoImg"
            companyName={companyNameCPS}
            companyLogo={companyLogo}
            imgWidth={imgWidth}
            imgHeight={imgHeight}
          />
        </div>
        <div className="company-data-placeholder">
          {!showJobsCount && (
            <ClusterHeaderTitleHeading className="company-cluster-header-title">
              {/* Note: the space after title below is required, DO NOT remove it. */}
              <span className="title">{title + ' '}</span>
            </ClusterHeaderTitleHeading>
          )}
          {showJobsCount && (
            <div>
              <ClusterHeaderTitleHeading className="d-inline company-cluster-header-title">
                {title}
              </ClusterHeaderTitleHeading>
              <span className="d-inline company-cluster-header-title">{` - ${formatNumber(
                jobsCountForHeader ?? data?.companyInfoJobs?.totalJobs ?? 0
              )} Jobs`}</span>
            </div>
          )}

          <div className="company-score d-flex z-mt-5">
            {overallScore && (
              <span className="smallGrey d-inline-flex align-items-center mr-3">
                {`Zippia Score ${overallScore}`}
                {starRatingCssName && (
                  <ul className={`ratingStars m-0 ${starRatingCssName}`}>
                    <li className="firstStarRated" />
                    <li className="secondStarRated" />
                    <li className="thirdStarRated" />
                    <li className="fourthStarRated" />
                    <li className="fifthStarRated" />
                  </ul>
                )}
              </span>
            )}
            {!!companyJobsCount &&
              displayFlagOfCompanyJobsPage &&
              subPageName !== CPP_SUBPAGES.JOBS && (
                <div className="smallGrey job-openings">
                  <a
                    href={buildCppSubpageUrl(companyLink, '', CPP_SUBPAGES.JOBS)}
                    className="alink"
                  >
                    Job Openings ({formatNumber(companyJobsCount)})
                  </a>
                </div>
              )}
          </div>

          {canClaimCompany && !claimedCompany && (
            <div
              className="company-claim-container"
              onClick={() => (window.location.href = `/employer/signup/?companyID=${companyID}`)}
            >
              {isVerifiedByEmployer ? (
                <>
                  <span className="claim-status-green-check">&#10004;</span>
                  <span className="company-claim-status">Verified</span>
                </>
              ) : (
                <>
                  <span className="claim-status-red-dot" />
                  <span className="company-claim-status">Claim This Company</span>
                </>
              )}
            </div>
          )}

          {claimedCompany && (
            <div
              className="update-company-profile"
              onClick={() => (window.location.href = `/employer/profile/${companyID}/`)}
            >
              <span className="update-company-profile-link">Update Company Profile</span>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default CompanyClusterHeaderTitle;
